/* ============
 * Edit Page
 * ============
 *
 * This is the page for editing a product.
 */
import addProductGroup from './../../productGroups/create/create.vue';
import productService from './../../../../services/product';
import productTagService from './../../../../services/productTag';
import productFormService from './../../../../services/form';
import productGroupService from './../../../../services/product-group';
import productPackagingService from '../../../../services/productPackaging';
import addProductPackaging from './../../../../pages/withNavigation/productPackagings/create/create.vue';
import addProducer from './../../../../components/addProducer/addProducer.vue';
import vmpSyncConfirmPopup from './../../../../components/vmpSyncConfirmPopup/vmpSyncConfirmPopup.vue';
import productTypeService from './../../../../services/productType';
import productSubtypeService from './../../../../services/productSubtype';
import priceFieldService from './../../../../services/priceField';
import productDepositService from './../../../../services/productDeposit';
import depositSystemService from './../../../../services/depositSystem';
import taxService from './../../../../services/tax';
import vmpService from './../../../../services/vinmonopolet';
import productTransformer from './../../../../transformers/product';
import Forms from './../../../../utils/forms/forms';
import exciseGroupService from './../../../../services/exciseGroup';
import store from './../../../../store';
import organizationSettingsService from './../../../../services/organizationSettings';
import countryService from './../../../../services/country';
import producerService from './../../../../services/producer';
import marketplaceProductTransformer from '../../../../transformers/marketplaceProduct';
import marketplaceProductService from '../../../../services/marketplaceProduct';
import productUNCodeService from '../../../../services/productUNCode';
import productRecommendationService from '../../../../services/productRecommendation';
import chartOfAccountService from './../../../../services/chartOfAccounts';
import accountService from './../../../../services/account';
import unitTypeService from './../../../../services/unitType';
import debounce from 'debounce';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      form: new Forms({
        productTypeId: {
          value: '',
          type: 'hidden',
        },
        productType: {
          value: '',
          type: 'cascader',
        },
        productSubtypeId: {
          value: '',
          type: 'hidden',
        },
        productSubtype: {
          value: '',
          type: 'cascader',
        },
        containsAlcohol: {
          value: '',
          type: 'switch',
        },
        // syncToWoo: {
        //   value: '',
        //   type: 'switch',
        // },
      }),
      forms: [],
      product: {
        fieldsJSON: {},
      },
      productMergeForm: new Forms({
        sourceProductId: {
          value: '',
          type: 'autocomplete',
          attributes: {
            isSearch: true,
            searchMethod: this.searchMethod,
            loading: true,
          },
        },
        destinationProductId: {
          value: '',
          type: 'autocomplete',
          attributes: {
            isSearch: true,
            searchMethod: this.searchMethod,
            loading: true,
          },
        },
      }),
      loading: false,
      tabIndex: '1',
      warehouses: [],
      initial: '',
      customSkuform: {
        update_sku: false,
        sku_initial: false,
        custom_sku: '',
        custom_sk_error: '',
      },
      transactionPerPage: 10,
      transactionLoading: true,
      batchFilter: {
        options: [],
        value: [],
        list: [],
        loading: true,
        batchDisplay: '',
      },
      warehouseFilter: {
        options: [],
        value: [],
        list: [],
        loading: true,
        warehouseDisplay: '',
      },
      showMarketplaceForm: false,
      marketplaceData: null,
      productDepositAmount: null,
    };
  },

  computed: {
    ...mapGetters({
      productGroups: 'allProductGroups',
      // transactions: 'allProductTransactions',
      // transactionsV2: 'allProductTransactionsV2',
      transactionsV2: 'productTransactionsV2',
      productTypes: 'allProductTypes',
      allProducers: 'allProducers',
      productDeposits: 'allProductDeposits',
      depositSystems: 'allDepositSystems',
      taxes: 'allTaxes',
      account: 'account',
      // deposits: 'allDeposits',
      groups: 'allExciseGroups',
      excisePackagingGroups: 'allExcisePackagingGroups',
      exciseBasicGroups: 'allExciseBasicGroups',
      products: 'allProducts',
      allProductTypes: 'allProductTypes',
      allProductSubtypes: 'allProductSubtypes',
      productTags: 'allProductTags',
      productPackagings: 'allProductPackagings',
      countries: 'allCountries',
      chartOfAccounts: 'allChartOfAccounts',
      priceFields: 'allPriceFields',
      productRecommendations: 'allProductRecommendations',
      unitTypes: 'allUnitTypes',
    }),

    sharedWarehouseNotice() {
      if (this.product.isSharedWarehouse) return this.$t('static.sharedWarehouseProduct');
      return false;
    },

    hasSkuInitial() {
      return this.customSkuform.custom_sku.includes(this.initial);
    },

    producers() {
      return [{ id: '', name: '' }, ...this.allProducers];
    },
    productType() {
      if (typeof this.form.productTypeId !== 'undefined') {
        return this.productTypes.find(type => type.id.toString() === this.form.productTypeId.toString());
      }
      return null;
    },

    ediGrapesMoving() {
      return this.account.plan === 'EDI Grapsmoving';
    },

    warehouseList() {
      return this.warehouses.map((c) => {
        let data = {
          warehouseId: c.warehouseId,
          name: c.warehouse.name,
          batchName: c.batchName,
          qty: c.qty,
        };
        if (this.hasProduction === false) {
          const { batchName, ...newData } = data;
          data = newData;
        }
        return data;
      });
    },
    // transactionList() {
    //   return this.transactions.map(c => ({
    //     via: `${c.via} - ${c.code}`,
    //     client: c.client,
    //     id: c.transactionId,
    //     key: `${c.via} ${c.transactionId}`,
    //     qty: c.qty,
    //     status: this.$t(`static.orders.status.${c.status}`),
    //     warehouse: c.warehouse,
    //     billingNumber: c.billingNumber,
    //     createdAt: c.createdAt,
    //   }));
    // },
    transactionListNew() {
      const newData = this.transactionsV2.items.map((c) => {
        let data = {
          via: `${c.via} #${c.code}`,
          client: c.customerName,
          batchName: c.batchName,
          id: c.parentModelId,
          key: `${c.via} ${c.code}`,
          beforeqty: c.beforeQty,
          qty: c.adjustmentQty,
          afterqty: c.afterQty,
          warehouse: c.warehouse,
          createdAt: c.createdAt,
        };
        if (this.hasProduction === false) {
          const { batchName, ...newData } = data;
          data = newData;
        }
        return data;
      });

      const self = this;
      return newData.filter((obj) => {
        if (self.batchFilter.batchDisplay !== '' && self.warehouseFilter.warehouseDisplay === '') {
          return self.batchFilter.batchDisplay === obj.batchName;
        } else if (self.batchFilter.batchDisplay === '' && self.warehouseFilter.warehouseDisplay !== '') {
          return self.warehouseFilter.warehouseDisplay === obj.warehouse;
        } else if (self.batchFilter.batchDisplay !== '' && self.warehouseFilter.warehouseDisplay !== '') {
          return self.batchFilter.batchDisplay === obj.batchName && self.warehouseFilter.warehouseDisplay === obj.warehouse;
        }
        return obj;
      });
    },

    checkHasInventory() {
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Inventory') {
            return true;
          }
        }
      }

      return false;
    },
    userHasMarketplace() {
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Marketplace') {
            return true;
          }
        }
      }

      return false;
    },
    userHasVinmonopolet() {
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Vinmonopolet') {
            return true;
          }
        }
      }

      return false;
    },

    hasEHFModule() {
      if (this.account.modules.length > 0) {
        return this.account.modules.find(module => module.name === 'EHF Catalogue');
      }
      return false;
    },

    hasProduction() {
      if (this.account.modules.length > 0) {
        if (this.account.modules.find(module => module.name === 'Production')) return true;
      }
      if (this.account.allowProducerBatches) return true;
      return false;
    },

    hasWooModule() {
      if (this.account.modules.length > 0) {
        if (this.account.modules.find(module => module.name === 'WordPress WooCommerce')) return true;
      }
      return false;
    },
  },

  watch: {

    'customSkuform.update_sku': function (value) {
      if (value === true) {
        this.customSkuform.update_sku = true;
      } else {
        this.customSkuform.update_sku = false;
      }
    },

    'customSkuform.custom_sku': function (value) {
      if (value.includes(this.initial)) {
        this.customSkuform.sku_initial = true;
      } else {
        this.customSkuform.sku_initial = false;
      }
    },

    warehouses(warehouses) {
      this.onUpdateWarehouseFilter(warehouses);
      this.onUpdateBatchFilter(warehouses);
    },

    /**
     * Listem to router changes, used to check query params that have changed to apply filters.
     *
     * @param  {Object} route Current route object.
     */
    $route() {
      this.show();
      this.all(1, this.transactionPerPage);
      this.form.setQuickForm('productGroupId', addProductGroup);
      this.hideProductConfig();
      this.hideProductDeposit();
      this.urlCurrentTab();
    },

    /**
     * Watches if user has Appointment module.
     *
     * @param  {Object} account    The account.
     */
    account() {
      this.toogleProductConfig(this.form.productTypeId);
      if (this.hasWooModule === false) {
        this.form.hideField('syncToWoo');
      }
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} productGroups    The product groups list.
     */
    productGroups(productGroups) {
      this.form.setOptions('productGroupId', productGroups.all);
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} productTypes    The product types list.
     */
    allProductTypes() {
      const productTypes = this.productTypes;
      if (productTypes) {
        const options = productTypes.reduce((groups, item) => {
          const group = (groups[item.group] || {
            label: this.$t(`static.products.types.${this.camalize(item.group)}`),
            value: item.group,
            children: [],
          });
          if (item.group) {
            group.children.push({
              label: this.$t(`static.products.types.${this.camalize(item.name)}`),
              value: item.id,
            });
            groups[item.group] = group;
          } else {
            groups[item.id] = {
              label: this.$t(`static.products.types.${this.camalize(item.name)}`),
              value: item.id,
            };
          }
          return groups;
        }, {});
        const opt = Object.keys(options).map((option) => {
          const item = options[option];
          if (item.children) {
            item.children = Object.keys(item.children).map((child) => {
              const c = item.children[child];
              if (c.children) {
                c.children = Object.keys(c.children).map(t => c.children[t]);
              }
              return c;
            });
          }
          return item;
        });
        this.form.setOptions('productType', opt.filter(pt => pt.label !== this.$t('static.products.types.bundle')).sort((a, b) => ((a.label > b.label) ? 1 : -1)));
      }
    },

    allProductSubtypes() {
      this.setOptionsForProductSubtype();
      this.getProductSubTypeValue(this.product);
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} productDeposits The product deposits list.
     */
    productDeposits(productDeposits) {
      // this.form.setOptions('productDepositId', productDeposits.all);
    },

    producers(producers) {
      const form = this.forms.find(f => f.name === 'detailsForm');
      if (form) {
        form.form.setOptions('producer', this.producers);
        form.form.producer = this.product.producer ? this.product.producer.toString() : '';
      }
    },

    productPackagings(productPackagings) {
      const form = this.forms.find(f => f.name === 'packagingForm');
      if (form) {
        form.form.setOptions('productPackagingId', productPackagings.all);
      }
    },

    productRecommendations(productRecommendations) {
      const form = this.forms.find(f => f.name === 'productInformation');
      if (form) {
        form.form.setOptions('recommendations', productRecommendations);
        form.form.setExtraAttr('recommendations', {
          multiple: true,
        });
      }
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} taxes    The taxes list.
     */
    taxes(taxes) {
      // this.priceForm.setOptions('taxId', taxes.all.map(tax => ({ id: tax.id, name: tax.taxPercentage })));
    },

    /**
     * Watches product type to hide or show product config.
     *
     * @param  {Integer} typeId The product type id.
     */
    'form.productTypeId': function (typeId) {
      // this.toogleProductConfig(typeId);
      if (this.form.productType && this.form.productType[0] == 'Beverage') { // beverage
        this.form.setField('containsAlcohol', 'switch');
      } else {
        this.form.setField('containsAlcohol', 'hidden');
      }
      if (typeId) {
        this.processForm(typeId);
        this.setOptionsForProductSubtype();
      }
    },

    /**
     * Watches product type to hide or show product config.
     *
     * @param  {Integer} typeId The product type id.
     */
    'form.productDepositId': function (depositId) {
      if (depositId > 0) {
        this.form.depositCheck = true;
      }
    },
    /**
     * Watches product type to assign the id value
     *
     * @param  {Array} productType    The product type.
     */
    'form.productType': function (arrayValue) {
      const [productyTypeId] = arrayValue.slice(-1);
      this.form.productTypeId = productyTypeId;
    },

    /**
     * Watches product subtype to assign the id value
     *
     * @param  {Array} productSubtype    The product type.
     */
    'form.productSubtype': function (arrayValue) {
      const [productSubtypeId] = arrayValue.slice(-1);
      this.form.productSubtypeId = productSubtypeId;
    },

    forms: {
      handler(value) {
        const self = this;
        const exciseForm = self.forms.find(f => f.name === 'exciseForm');
        const packagingForm = self.forms.find(f => f.name === 'packagingForm');
        const detailsForm = self.forms.find(f => f.name === 'detailsForm');
        const onlineStoreForm = self.forms.find(f => f.name === 'onlineStore');
        value.forEach((value2) => {
          if (value2.name === 'packagingForm') {
            if (value2.form.productPackagingId) {
              if (exciseForm) {
                const packaging = self.productPackagings.all.find(f => f.id === parseInt(value2.form.productPackagingId));
                if (packaging && packaging.excisePackagingGroup !== null) { exciseForm.form.excisePackagingGroup = packaging.excisePackagingGroup; }
                if (packaging && packaging.exciseBasicGroup !== null) { exciseForm.form.exciseBasicGroup = packaging.exciseBasicGroup; }
                if ((packaging && packaging.overrideProducts && packaging.overrideProducts === 1) || this.sharedWarehouseNotice) {
                  if (packaging && packaging.excisePackagingGroup !== null) {
                    exciseForm.form.disableField('excisePackagingGroup');
                  }
                  if (packaging && packaging.exciseBasicGroup !== null) {
                    exciseForm.form.disableField('exciseBasicGroup');
                  }
                } else {
                  exciseForm.form.enableField('exciseBasicGroup');
                  exciseForm.form.enableField('excisePackagingGroup');
                }
              }
            } else {
              onlineStoreForm.form.hideField('sellInCase');
            }

            if (value2.form.depositSystemId) {
              if (packagingForm) packagingForm.form.enableField('productDepositId');
            } else if (!value2.form.depositSystemId) {
              if (packagingForm) packagingForm.form.disableField('productDepositId');
            }
          }

          if ((detailsForm && detailsForm.form.alcohol_percentage >= 0.7) || (exciseForm && exciseForm.form.exciseAlcoholGroup !== '')) {
            self.form.containsAlcohol = true;
          } else {
            self.form.containsAlcohol = false;
          }

          if (value2.name === 'onlineStore') {
            if (value2.form.sellInCase === true) {
              const currentPackaging = self.productPackagings.all.filter(obj => obj.id === packagingForm.form.productPackagingId);
              if (currentPackaging !== undefined && currentPackaging.length != 0) {
                onlineStoreForm.form.minQty = currentPackaging[0].qtyInCrate;
                onlineStoreForm.form.groupOf = currentPackaging[0].qtyInCrate;
                onlineStoreForm.form.disableField('minQty');
                onlineStoreForm.form.disableField('groupOf');
              }
            } else {
              onlineStoreForm.form.enableField('minQty');
              onlineStoreForm.form.minQty = 1;
              onlineStoreForm.form.enableField('groupOf');
              onlineStoreForm.form.groupOf = 1;
            }
          }
        });
      },
      deep: true,
    },

    tabIndex(value) {
      this.assignTab(value);
    },
  },

  mounted() {
    this.form.setQuickForm('productGroupId', addProductGroup);
    this.hideProductConfig();
    this.hideProductDeposit();
    this.show();
    this.form.setExtraAttr('productGroupId', {
      multiple: true,
    });
    this.form.hideField('productTypeId');
    this.urlCurrentTab();
    this.assignTab(this.tabIndex);
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalSize: 'SET_MODAL_SIZE',
      setModalProps: 'SET_MODAL_PROPS',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
    }),

    onImageRemove() {
      productService.removeImage(store.state.route.params.id)
      .then(() => {
        this.$message({
          message: this.$t('static.products.delete.imageSuccess'),
          type: 'success',
        });
      });
    },

    customSkuKeydown(e) {
      if (!(/^[a-zA-Z0-9-_]+$/.test(e.key))) {
        e.preventDefault();
      }
    },

    addSkuInitial(value) {
      if (value === true) {
        this.customSkuform.custom_sku = `${this.initial}${this.customSkuform.custom_sku}`;
      } else {
        this.customSkuform.custom_sku = this.customSkuform.custom_sku.replace(`${this.initial}`, '');
      }
    },

    perPage(size) {
      accountService.rememberPerPage('post', { from: 'bill', perPage: size })
        .then((data) => {
          this.transactionPerPage = data.size;
        }).catch((error) => {
          console.log(error);
        });
    },

    assignTab(value) {
      let tab = '';
      if (value == '5') {
        tab = '#childProduct';
      } else if (value == '4') {
        tab = '#mergeProduct';
      } else if (value == '3') {
        tab = '#transactions';
      } else if (value == '2') {
        tab = '#inventory';
      } else {
        tab = '#productInfo';
      }
      history.pushState({}, null, `/#${this.$route.path}${tab}`);
    },

    urlCurrentTab() {
      if (this.$router.currentRoute.hash == '#childProduct') {
        this.tabIndex = '5';
      } else if (this.$router.currentRoute.hash == '#mergeProduct') {
        this.tabIndex = '4';
      } else if (this.$router.currentRoute.hash == '#transactions') {
        this.tabIndex = '3';
      } else if (this.$router.currentRoute.hash == '#inventory') {
        this.tabIndex = '2';
      } else {
        this.tabIndex = '1';
      }
    },

    informationTextOverrides(formName) {
      if (formName === 'marketplace') {
        if (this.product.marketplaceStatus === 'Pending') {
          return 'Your product is still under review by the admin.';
        } else if (this.product.marketplaceStatus === 'Active' && this.product.marketplaceHasPending) {
          return 'Your product details update is still under review by the admin.';
        }
        return '';
      }
      return '';
    },

    vmpImportHandler() {
      if (!this.userHasVinmonopolet) {
        this.$alert(this.$t('static.products.syncVmp.noModuleWarning'), 'Warning', {
          dangerouslyUseHTMLString: true,
        });
        return;
      }
      const formIndex = this.forms.findIndex(f => f.name === 'productIndentification');
      const vmp = this.forms[formIndex].form.vmp;
      if (!vmp) {
        this.$message({
          message: this.$t('static.products.syncVmp.inputRequired'),
          type: 'error',
        });
        return;
      }
      // this.forms[formIndex].form.disableField('vmp');

      vmpService.findProduct(vmp)
        .then((data) => {
          this.forms[formIndex].form.loading = false;
          if (data) {
            this.setModalContent(() => vmpSyncConfirmPopup);
            this.setModalSize('full');
            this.toggleModal(true);
            this.setModalProps({
              vmpData: data,
              onConfirm: this.populateVmpData,
            });
          }
        })
        .catch(() => {
          this.$message({
            message: this.$t('static.product.create.vmp.warning'),
            type: 'error',
          });
          // this.forms[formIndex].form.enableField('vmp');
          this.forms[formIndex].form.loading = false;
        });
    },

    setOptionsForProductSubtype() {
      if (!this.allProductSubtypes.length) {
        this.form.hideField('productSubtype');
        return;
      }
      this.form.showField('productSubtype');
      if (this.form.productType.length) {
        const typeId = this.form.productType[this.form.productType.length - 1];

        const options = [...this.allProductSubtypes]
          .filter(s => +s.productTypeId === +typeId)
          .reduce((groups, item) => {
            const group = groups[item.type] || {
              label: item.type,
              value: item.type,
              children: [],
            };
            if (item.type) {
              group.children.push({
                label: item.name,
                value: item.id,
              });
              groups[item.type] = group;
            } else {
              groups[item.id] = {
                label: item.name,
                value: item.id,
              };
            }
            return groups;
          }, {});
        const opt = Object.keys(options).map((option) => {
          const item = options[option];
          if (item.children) {
            item.children = Object.keys(item.children).map((child) => {
              const c = item.children[child];
              if (c.children) {
                c.children = Object.keys(c.children).map(t => c.children[t]);
              }
              return c;
            });
          }
          return item;
        });
        if (opt.length) {
          this.form.setOptions(
            'productSubtype',
            opt.sort((a, b) => (a.label > b.label ? 1 : -1))
          );
          return;
        }
        this.form.hideField('productSubtype');
        return;
      }
    },

    populateVmpData(data) {
      this.forms.find(f => f.name === 'productInformation').form.assignData({
        name: data.name,
      });
      this.forms.find(f => f.name === 'productIndentification').form.assignData({
        vmp: data.vmp,
        gtin: data.gtin,
      });
      this.forms.find(f => f.name === 'detailsForm').form.assignData({
        producer: data.producer,
        country: data.country,
        region: data.region,
        subRegion: data.subRegion,
        vintage: data.vintage,
        containsAlcohol: +(data.alcoholPercentage > 0),
        alcohol_percentage: data.alcoholPercentage,
        bottle_volume: data.bottleVolume,
        cork_type: data.corkType,
        packaging_type: data.packagingType,
        weightMultipack: data.weightMultipack,
        sugar: data.sugar,
        acid: data.acid,
        fullness: data.fullness,
        freshness: data.freshness,
        bitterness: data.bitterness,
        tannins: data.tannins,
        colour: data.colour,
        odour: data.odour,
        taste: data.taste,
        storagePorential: data.storagePorential,
        organic: data.organic,
        biodynamic: data.biodynamic,
        locallyProduced: data.locallyProduced,
        environmentallySmart: data.environmentallySmart,
        freeOrLowOnGluten: data.freeOrLowOnGluten,
        kosher: data.kosher,
        storagePotential: data.storagePotential,
        ingredients: data.ingredients,
      });
      this.forms.find(f => f.name === 'priceForm').form.assignData({
        retailPriceVmp: data.retailPriceVmp,
        ddpVmp: data.ddpVmp,
      });
    },

    getProductTypeValue(product) {
      const productTypeValue = [];
      const productType = this.productTypes.find(type => type.id.toString() === product.productTypeId.toString());

      if (productType) {
        if (productType.group) {
          productTypeValue.push(productType.group);
        }
        productTypeValue.push(productType.id);
      }
      return productTypeValue;
    },

    getProductSubTypeValue(product) {
      const productSubtypeValue = [];
      const productSubtype = this.allProductSubtypes.find(type => +type.id === +product.productSubtypeId);

      if (productSubtype) {
        if (productSubtype.type) {
          productSubtypeValue.push(productSubtype.type);
        }
        productSubtypeValue.push(productSubtype.id);
      }
      return productSubtypeValue;
    },

    toogleProductConfig(typeId) {
      const hasAppointment = this.account.modules !== undefined ? this.account.modules.filter(m => (
        m.name === 'Appointment'
      )).length > 0 : false;
      if (typeId) {
        const type = this.productTypes.filter(t => (
          typeId.toString() === t.id.toString()
        ));

        if (type.length > 0 && type[0].name === 'Service' && hasAppointment) {
          this.showProductConfig();
        } else {
          this.hideProductConfig();
        }
      }
    },

    searchMethod(search, field) {
      return Promise.all([
        productService.searchAll({ search }),
      ]);
    },
    /**
     * Hide fields from product configuration.
     */
    hideProductConfig() {
      this.form.hideField('breaktime');
      this.form.hideField('duration');
      this.form.hideField('appointable');
    },

    /**
     * Show fields from product configuration.
     */
    showProductConfig() {
      this.form.showField('breaktime');
      this.form.showField('duration');
      this.form.showField('appointable');
    },

    toggleProductDeposit(depositCheck) {
      if (depositCheck) {
        this.showProductDeposit();
      }

      if (!depositCheck) {
        this.hideProductDeposit();
      }
    },

    /**
     * Hide field from product deposit
     */
    hideProductDeposit() {
      this.form.hideField('productDepositId');
    },

    /**
     * Show field from product deposit
     */
    showProductDeposit() {
      this.form.showField('productDepositId');
    },

    /**
     * Method to update the product.
     *
     * @param  {Object} product    The product
     * @param  {Function} errorCallback    The error callback
     */
    update() {
      const me = this;
      this.form.loading = true;
      let obj = Object.assign({}, this.form.data());
      const priceFieldValues = {};
      for (let i = 0; i < this.forms.length; i++) {
        obj = Object.assign(obj, this.forms[i].form.data());
        this.forms[i].form.loading = true;
      }
      obj = Object.assign(obj, { custom_sku: me.customSkuform.custom_sku, update_sku: me.customSkuform.update_sku });

      const product = productTransformer.send(
        obj
      );

      this.priceFields.all.forEach((price) => {
        product[price.field] = obj[price.field];
      });
      productService.update(store.state.route.params.id, product)
        .then(() => {
          if (product.marketplace_enabled) {
            this.submitPartner(product);
          } else {
            this.$message({
              message: this.$t('static.products.edit.success'),
              type: 'success',
            });
            this.$router.push({
              name: 'products.index',
            });
          }
        })
        .catch((errors) => {
          if ('icon' in errors) {
            if (errors.icon) {
              errors.icon = errors.icon.url;
            }
          }
          for (let i = 0; i < me.forms.length; i++) {
            me.forms[i].form.recordErrors(errors);
            me.forms[i].form.loading = false;
          }
          if (errors.custom_sku != undefined && errors.custom_sku.length > 0) {
            me.customSkuform.custom_sk_error = errors.custom_sku[0];
          }
          if (errors.productSubtypeId) {
            errors.productSubtype = errors.productSubtypeId;
          }
          console.log(errors);
          this.form.recordErrors(errors);
          this.form.loading = false;
          this.$message({
            message: this.$t('static.products.edit.error'),
            type: 'error',
            duration: 15000,
            dismissible: true,
            showClose: true,
          });
        });
    },

    submitPartner(product) {
      const resources = [];
      if (product.marketplace_enabled) {
        const marketplaceProduct = marketplaceProductTransformer.send(this.marketplaceData.data());
        resources.push(marketplaceProductService.store(this.product.id, marketplaceProduct));
      }
      Promise.all(resources)
        .then(() => {
          this.form.loading = false;
          this.$message({
            message: this.$t('static.products.edit.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'products.index',
          });
        }).catch((errors) => {
          this.form.loading = false;
          if ('image' in errors) {
            if (errors.image) {
              errors.image = errors.image.url;
              if (errors.image[0] && errors.image[0] === 'Invalid Image') {
                errors.image[0] = this.$t('static.products.lokalbrygg.messages.imageError');
              }
            }
          }
          if (product.marketplace_enabled) {
            this.marketplaceData.recordErrors(errors);
          }
          this.$message({
            message: this.$t('static.products.edit.error'),
            type: 'error',
            showClose: true,
            duration: 15000,
          });
        });
    },

    destroy() {
      this.$confirm(this.$t('static.products.delete.confirm'), this.$t('static.products.delete.title'), {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        // delete goes here...
        productService.destroy(store.state.route.params.id)
          .then(() => {
            this.$message({
              message: this.$t('static.products.delete.success'),
              type: 'success',
            });
            this.$router.push({
              name: 'products.index',
            });
          })
          .catch((errors) => {
            this.$message({
              message: errors.message,
              type: 'error',
            });
          });
      }).catch(() => {});
    },

    /**
     * Fetches the product object for editing.
     */
    show() {
      this.loading = true;
      Promise.all([
        productService.show(store.state.route.params.id),
        productGroupService.all(),
        productTypeService.all(),
        productSubtypeService.all(),
        productDepositService.all(),
        depositSystemService.all(),
        // productService.transactions({ id: store.state.route.params.id }),
        // productService.transactionsV2({ id: store.state.route.params.id }),
        taxService.all(),
        // productService.all(),
        organizationSettingsService.show(),
        productTagService.all(),
        exciseGroupService.all(),
        exciseGroupService.packaging(),
        exciseGroupService.basic(),
        productPackagingService.all(),
        producerService.all(),
        countryService.all(),
        chartOfAccountService.all(),
        priceFieldService.all(1),
        productRecommendationService.all(),
        unitTypeService.all(),
      ]).then((data) => {
        this.loading = false;
        this.product = data[0];
        if (this.product.marketplaceEnabled) {
          this.showMarketplaceForm = true;
        }
        if (this.product.fieldsJSON.containsAlcohol) {
          this.form.containsAlcohol = true;
        }

        /* if(typeof data[0].productTypeId !== 'undefined'){
           this.processForm(data[0].productTypeId);

         }*/
        this.form.assignData(Object.assign({}, data[0], { productTypeId: null }));
        this.form.productType = this.getProductTypeValue(this.product);
        this.form.productSubtype = this.getProductSubTypeValue(this.product);
        this.customSkuform.custom_sku = data[0].number;
        this.initial = data[0].initial;
        this.form.disableField('sku');
        /* this.priceForm.assignData(data[0]);
         this.detailsForm.assignData(data[0].fieldsJSON);*/
        this.warehouses = data[0].warehouses;
        // this.productMergeForm.setOptions('sourceProductId', data[6]);
        // this.productMergeForm.setOptions('destinationProductId', data[6]);
        this.productMergeForm.setFieldValue('destinationProductId', data[0]);
        this.productMergeForm.setDisplays('sourceProductId', data[6].productInfoDisplay);
        this.productMergeForm.setDisplays('destinationProductId', data[6].productInfoDisplay);
        this.all(1, this.transactionPerPage);
 
        if (this.sharedWarehouseNotice) {
          this.form.disableField('productType');
          this.form.disableField('productSubtype');
          this.form.disableField('containsAlcohol');
        }
      });
    },

    link(warehouse) {
      const routeData = this.$router.resolve({
        params: { id: warehouse.warehouseId },
        name: 'warehouse.edit',
      });
      window.open(routeData.href, '_blank');
    },
    transactionLink(trans) {
      let name = '';
      if (trans.via.indexOf('Stock count') !== -1) {
        name = 'inventory.stock.view';
      } else if (trans.via.indexOf('Stock Adjustment') !== -1) {
        name = 'inventory.adjustment.view';
      } else if (trans.via.indexOf('Order') !== -1) {
        name = 'orders.edit';
      } else if (trans.via.indexOf('Purchase') !== -1) {
        name = 'inventory.purchase.view';
        // Transaction V2.
      } else if (trans.via.indexOf('SO') !== -1) {
        name = 'orders.edit';
      } else if (trans.via.indexOf('OC') !== -1) {
        name = 'orders.edit';
      } else if (trans.via.indexOf('PO') !== -1) {
        name = 'inventory.purchase.view';
      } else if (trans.via.indexOf('AJ') !== -1) {
        name = 'inventory.adjustment.view';
      } else if (trans.via.indexOf('SC') !== -1) {
        name = 'inventory.stock.view';
      } else if (trans.via.indexOf('TW') !== -1) {
        name = 'inventory.transfer.view';
      } else if (trans.via.indexOf('RS') !== -1) {
        name = 'bills.creditNote';
      } else if (trans.via.indexOf('TC') !== -1) {
        name = 'orders.edit';
      }
      const routeData = this.$router.resolve({
        params: { id: trans.id },
        name,
      });
      window.open(routeData.href, '_blank');
    },
    /**
     * Go to edit view for product group
     *
     * @parObject} productGroup The product group object
     */
    editProduct(product) {
      this.$router.push({
        name: 'products.edit',
        params: {
          id: product.id,
        },
      });
    },

    mergeProduct() {
      const productMergeData = [];
      const productMergeFormData = this.productMergeForm.data();

      this.productMergeForm.loading = true;
      Object.keys(this.productMergeForm.fields).map((field) => {
        productMergeData[field] = productMergeFormData[field].id;
      });

      productService.merge(productMergeData)
        .then(() => {
          this.$message({
            message: this.$t('static.products.merge.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'products.index',
          });
        })
        .catch((errors) => {
          this.$message({
            message: errors.message,
            type: 'error',
          });
          this.productMergeForm.loading = false;
        });
    },

    processForm(typeId) {
      const me = this;
      me.loading = true;
      // this.toogleProductConfig(typeId);
      Promise.all([
        productFormService.fields(typeId),
      ]).then((data) => {
        me.forms = [];

        for (let i = 0; i < data[0].length; i++) {
          const fields = {};
          for (let f = 0; f < data[0][i].fields.length; f++) {
            const field = data[0][i].fields[f];

            const new_field = {
              type: field.fieldType.type,
              value: field.defaultValue,
            };

            fields[field.name] = new_field;
          } 
          const infoOverride = this.informationTextOverrides(data[0][i].name);
          const form = {
            name: data[0][i].name,
            information: infoOverride || data[0][i].information,
            form: new Forms(fields),
          };

          if (data[0][i].name !== 'onlineStore' && this.sharedWarehouseNotice) {
            form.form.disabled = Object.keys(form.form.fields);
          }

          Object.keys(fields).map((value, key) => {
            if (value === 'taxId') {
              form.form.setOptions('taxId', me.taxes.all.map(tax => ({ id: tax.id, name: tax.taxPercentage })));
            } else if (value === 'productGroupId') {
              form.form.setOptions('productGroupId', me.productGroups.all);
              form.form.setExtraAttr('productGroupId', {
                multiple: true,
              });
            } else if (value === 'productTagId') {
              form.form.setOptions('productTagId', me.productTags.all.map(tag => ({
                id: tag.id,
                name: tag.tag,
              })));
              form.form.setExtraAttr('productTagId', {
                multiple: true,
              });
            } else if (value === 'productPackagingId') {
              form.form.setOptions('productPackagingId', this.productPackagings.all);
              form.form.setQuickForm('productPackagingId', addProductPackaging);
            } else if (value === 'recommendations') {
              form.form.setOptions('recommendations', this.productRecommendations);
              form.form.setExtraAttr('recommendations', {
                multiple: true,
              });
            } else if (value === 'sku') {
              form.form.hideField('sku');
            } else if (value === 'vmp') {
              form.form.setExtraAttr('vmp', {
                hasButton: true,
                buttonLabel: this.$t('static.products.create.vmp.fetch'),
                buttonHandler: this.vmpImportHandler,
              });
            } else if (value === 'productDepositId') {
              form.form.setOptions('productDepositId', me.productDeposits.all.map(deposit => ({ id: deposit.id, name: deposit.name })));
            } else if (value === 'depositSystemId') {
              form.form.setOptions('depositSystemId', me.depositSystems.all.map(depositSystem => ({ id: depositSystem.id, name: depositSystem.name })));
            } else if (value === 'exciseAlcoholGroup') {
              form.form.setOptions('exciseAlcoholGroup', me.groups.map(c => ({ id: c.id, name: `${c.description}` })));
            } else if (value === 'excisePackagingGroup') {
              form.form.setOptions('excisePackagingGroup', me.excisePackagingGroups.map(c => ({ id: c.id, name: `${c.description}` })));
            } else if (value === 'producer') {
              form.form.setOptions('producer', this.producers);
              form.form.setQuickForm('producer', addProducer);
            } else if (value === 'country') {
              form.form.setOptions('country', me.countries.items.map(c => ({ id: c.name, name: this.$t(`country.translated.${c.code}`) })));
            } else if (value === 'exciseBasicGroup') {
              form.form.setOptions('exciseBasicGroup', me.exciseBasicGroups.map(c => ({ id: c.id, name: `${c.description}` })));
            } else if (value === 'subType') {
              if (me.productType.subTypes) {
                form.form.setOptions('subType', me.productType.subTypes.map((subType) => {
                  let options = [];
                  const subTypes = subType.types.map(type => ({
                    label: type,
                    value: type,
                  }));
                  if (subType.group) {
                    options = {
                      value: subType.group,
                      label: subType.group,
                      children: subTypes,
                    };
                  } else {
                    options = subTypes;
                  }
                  return options;
                }));
              } else {
                form.form.hideField('subType');
              }
            } else if (value === 'chartOfAccounts') {
              if (me.chartOfAccounts && me.chartOfAccounts.all && Array.isArray(me.chartOfAccounts.all)) {
                const options = me.chartOfAccounts.all.map(c => ({ id: c.id, name: `${c.name}` }));
                options.unshift({ id: 0, name: 'None' });
                form.form.setOptions('chartOfAccounts', options);
              }
            } else if (value == 'unProductCodeId') {
              if (!me.hasEHFModule) {
                form.form.hideField('unProductCodeId');
              } else {
                form.form.setExtraAttr('unProductCodeId', {
                  isSearch: true,
                  searchMethod: this.unProductCodeSearch,
                  loading: true,
                });
              }
            } else if (value == 'orderableUnitId') {
              const options = me.unitTypes.all.map(c => ({ id: c.id, name: `${c.name}` }));
              form.form.setOptions('orderableUnitId', options);
            }
          });

          if (form.name === 'detailsForm') {
            form.form.assignData(me.product.fieldsJSON);
            form.form.recommendations = me.product.recommendations;
            form.form.producer = me.product.producer || '';
          } else {
            form.form.assignData(me.product);
          }

          if (form.name === 'priceForm') {
            this.priceFields.all.forEach((price) => {
              if (price.field === me.product[price.field]) {
                form.form[price.field] = me.product[price.field] || '';
              }
            });
          }


          if (['marketplace'].includes(form.name)) {
            if (form.name === 'marketplace' && this.userHasMarketplace) {
              me.forms.push(form);
              const marketplaceIndex = me.forms.findIndex(f => f.name === 'marketplace');
              this.$watch(`forms.${marketplaceIndex}.form.marketplaceEnabled`, this.isMarketplaceEnabled, { deep: true });
            }
          } else {
            me.forms.push(form);
          }
        }

        me.loading = false;
      });
    },
    isMarketplaceEnabled(active) {
      this.showMarketplaceForm = !!active;
    },
    productDepositUpdate(productDepositId) {
      const productDeposit = this.productDeposits.all.find(pd => +pd.id === +productDepositId);
      if (productDeposit) {
        this.productDepositAmount = productDeposit.amount;
      }
    },
    showMarketplaceModal() {
      this.setModalProps({
        product: this.product,
        onSave: (status, price) => {
          if (!status) {
            const marketplaceIndex = this.forms.findIndex(f => f.name === 'marketplace');
            this.forms[marketplaceIndex].form.marketplaceEnabled = false;
          }
          if (price) {
            const priceFormIndex = this.forms.findIndex(f => f.name === 'priceForm');
            this.forms[priceFormIndex].form.marketplace = price;
          }
          this.setModalCloseOnClick(true);
          this.setModalShowClose(true);
          this.setModalCloseOnEscape(true);
        },
      });
    },
    marketplacePriceUpdated(price) {
      const priceFormIndex = this.forms.findIndex(f => f.name === 'priceForm');
      this.forms[priceFormIndex].form.marketplace = price;
    },

    camalize(str) {
      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    },

    /**
     * Fetches paginated transaction.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed on a page.
     */
    all: debounce(function (page, limit) {
      if (this.transactionLoading === false) this.transactionLoading = true;
      const filters = {
        batchDisplay: this.batchFilter.batchDisplay,
        warehouseDisplay: this.warehouseFilter.warehouseDisplay,
      };
      const params = {
        id: this.$route.params.id,
        page,
        limit,
        filter: JSON.stringify(filters),
      };
      productService.transactionsV2(params)
        .then(() => {
          setTimeout(() => { if (this.transactionLoading === true) this.transactionLoading = false; }, 500);
        }).catch(() => {
          setTimeout(() => { if (this.transactionLoading === true) this.transactionLoading = false; }, 500);
        });
    }, 800),

    /**
     * Clear batch
     */
    clearBatchFilter() {
      this.batchFilter.batchDisplay = '';
      this.all(1, this.transactionPerPage);
    },

    /**
     * Focus batch filter
     */
    focusBatchFilter() {

    },

    /**
     * Filter batches
     */
    getFilterBatches(query) {
      this.batchFilter.loading = true;
      if (query !== '') {
        setTimeout(() => {
          this.batchFilter.options = this.batchFilter.list.filter(item => item.label.toLowerCase()
            .indexOf(query.toLowerCase()) > -1);
          this.batchFilter.loading = false;
        }, 200);
      } else {
        this.batchFilter.options = [];
        this.batchFilter.loading = false;
      }
    },

    /**
     * On update batches
     */
    onUpdateBatchFilter(value) {
      const unique = value.filter((set => f => !set.has(f.batchName) && set.add(f.batchName))(new Set()));
      return this.batchFilter.list = unique.map(item => ({ value: `${item.batchName}`, label: `${item.batchName}` }));
    },

    /**
     * Event batches
     */
    eventBatchFilter(value) {
      this.transactionLoading = true;
      this.batchFilter.batchDisplay = value;
      this.all(1, this.transactionPerPage);
    },

    /**
     * Clear warehouse
     */
    clearWarehouseFilter() {
      this.warehouseFilter.warehouseDisplay = '';
      this.all(1, this.transactionPerPage);
    },

    /**
     * Focus warehouse filter
     */
    focusWarehouseFilter() {

    },

    /**
     * Filter warehouse
     */
    getFilterWarehouse(query) {
      this.warehouseFilter.loading = true;
      if (query !== '') {
        setTimeout(() => {
          this.warehouseFilter.options = this.warehouseFilter.list.filter(item => item.label.toLowerCase()
            .indexOf(query.toLowerCase()) > -1);
          this.warehouseFilter.loading = false;
        }, 200);
      } else {
        this.warehouseFilter.options = [];
        this.warehouseFilter.loading = false;
      }
    },

    /**
     * On update warehouse
     */
    onUpdateWarehouseFilter(value) {
      const unique = value.filter((set => f => !set.has(f.warehouseId) && set.add(f.warehouseId))(new Set()));
      return this.warehouseFilter.list = unique.map(item => ({ value: `${item.warehouse.name}`, label: `${item.warehouse.name}` }));
    },

    /**
     * Event warehouse
     */
    eventWarehouseFilter(value) {
      this.transactionLoading = true;
      this.warehouseFilter.warehouseDisplay = value;
      this.all(1, this.transactionPerPage);
    },

    unProductCodeSearch(search) {
      return Promise.all([
        productUNCodeService.search({ search }),
      ]);
    },

  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
    VTable: require('./../../../../components/table/table.vue'),
    VMarketplace: require('../../../../components/marketplaceProductForm/marketplaceProductForm.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/products/edit/edit.js